import { createContext, useContext } from 'react'
import { ConnectedUser } from '@ucc/admin-global-state'

const context = createContext<ConnectedUser | null>(null)
export const useConnectedUserContext = (): ConnectedUser | null => useContext(context)
export default context
